import React from "react";
// eslint-disable-next-line no-unused-vars
import { DownloadOutlined } from "@ant-design/icons";
// eslint-disable-next-line no-unused-vars
import { BiSolidDashboard } from "react-icons/bi";
// eslint-disable-next-line no-unused-vars
import { MdLocalActivity, MdAssignmentInd } from "react-icons/md";
import {
  HiOutlineClipboardDocumentList,
  // eslint-disable-next-line no-unused-vars
  HiOutlineSquares2X2,
  // eslint-disable-next-line no-unused-vars
  HiOutlineDocumentChartBar,
  // eslint-disable-next-line no-unused-vars
  HiOutlineCog8Tooth,
  // eslint-disable-next-line no-unused-vars
  HiOutlineArrowPathRoundedSquare,
  // eslint-disable-next-line no-unused-vars
  HiOutlineCube,
  HiOutlineLockClosed,
} from "react-icons/hi2";
// eslint-disable-next-line no-unused-vars
import { HiOutlineMail, HiOutlineMailOpen } from "react-icons/hi";
// eslint-disable-next-line no-unused-vars
import { RiExchangeBoxLine } from "react-icons/ri";
import {
  LuFileChartColumnIncreasing,
  LuMessageCircleQuestion,
  LuPackageSearch,
} from "react-icons/lu";
const routeConfigAM = [
  {
    id: "Dashboards",
    title: "Overview",
    messageId: "sidebar.application",
    type: "group",
    children: [
      {
        id: "reports",
        title: "Reports",
        messageId: "menu.reports",
        icon: <LuFileChartColumnIncreasing />,
        path: "/reports",
      },
      {
        id: "settings",
        title: "Settings",
        messageId: "menu.settings",
        icon: (
          <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
            settings
          </span>
        ),
        type: "collapse",
        children: [
          {
            id: "changepassword",
            title: "Change Password",
            messageId: "menu.cp",
            icon: <HiOutlineLockClosed />,
            path: "/changepassword",
          },
          {
            id: "subscription",
            title: "Reports Subscription",
            messageId: "menu.sub",
            icon: <HiOutlineMail />,
            path: "/subscription",
          },
        ],
      },
      {
        id: "jobs-tracker",
        title: "Jobs Tracker",
        messageId: "menu.jobs",
        icon: <HiOutlineClipboardDocumentList />,
        path: "/jobs-tracker",
      },
      {
        id: "track-order",
        title: "Track Order",
        messageId: "menu.track",
        icon: <LuPackageSearch />,
        path: "/track-order",
      },
      {
        id: "Help&Support",
        title: "Help & Support",
        messageId: "menu.track",
        icon: <LuMessageCircleQuestion />,
        path: "/Help&Support",
      },
    ],
  },
];

export function useRouteConfigAM() {
  return routeConfigAM;
}

export default routeConfigAM;
